import { ConfigFn } from '@config/types'

const config = (({ publication }) =>
  ({
    leserreporterPageUrl:
      publication === 'romandie'
        ? ''
        : '/schweiz/werde-leserreporter-in-schicke-uns-deine-videos-fotos-und-inputs-blick-will-deine-story-id17849625.html',
  }) as const) satisfies ConfigFn

export default config
